module.exports = __webpack_public_path__ + "img/left.504d33ce.svg";